(function () {
  'use strict';

  angular
    .module('web2print.payment')
    .controller('PaymentRedirectController', PaymentRedirectController);

  PaymentRedirectController.$inject = ['$rootScope', '$http', '$localStorage', '$state', '$stateParams', '$timeout',
    '$window', 'Common', 'paymentFactory', '$translate'];

  /* @ngInject */
  function PaymentRedirectController ($rootScope, $http, $localStorage, $state, $stateParams, $timeout, $window,
    Common, paymentFactory, $translate) {

    activate();

    function activate () {
      translateProduct('PAY'); //horrible fix to get translations from S3 before GA is triggered.
      console.log('Payment loading');
      $state.href('main.payment-redirect', {}, {
        absolute: true
      });

      const transactionId = $stateParams.transactionId;
      const responseCode = $stateParams.responseCode;

      // We are redirected back to the payment page from payment terminal
      if (transactionId) {
        handleTerminalRedirect(transactionId, responseCode);
      } else {
        $state.go('main.payment');
      }
    }

    function handleTerminalRedirect (transactionId, responseCode) {
      if (responseCode === 'OK') {
        console.log('terminal OK');
        const orderId = Common.get('orderId');

        $http.patch(web2print.env.ordersBaseUrl + 'activate/' + orderId, {})
          .then(function (response) {
            console.log(response);
            Common.set('paymentStatus', 'SUCCESS');

            try { // In case something goes awry
              pushGtmPurchase(transactionId);
            } catch (error) {
              console.error(error);
            }

            $state.go('main.receipt');
          }, function (error) {
            let errCode = 'ActivationError';

            if (typeof error.data.errorMessage === 'object' && error.data.errorMessage.paymentStatus) {
              errCode = error.data.errorMessage.paymentStatus;
            }

            paymentFactory.setPaymentResponseCode(errCode);
            Common.set('paymentStatus', 'FAILED');
            $state.go('main.payment');
          });

      } else if (responseCode === 'Cancel') {
        console.log('terminal canceled');
        delete $localStorage.orderId;
        paymentFactory.setPaymentResponseCode(responseCode);
        $state.go('main.payment');
      } else {
        console.log('terminal NOT OK');
        delete $localStorage.orderId;
        paymentFactory.setPaymentResponseCode('Failed');
        $state.go('main.payment');
      }
    }

    function pushGtmPurchase (transactionId) {
      const pricing = Common.get('pricing', {});

      const transactionInfo = {
        event: 'transaction',
        ecommerce: {
          currencyCode: pricing.ISO_units,
          purchase: {
            actionField: {
              id: transactionId,
              revenue: toDecimalPrice(pricing.totalWithVAT),
              tax: toDecimalPrice(pricing.VATAmount),
            },
            products: mapForGTM(groupProducts()),
          },

        }
      };

      $window.dataLayer.push(transactionInfo);
    }

    function groupProducts () {
      const pricing = Common.get('pricing');
      if (pricing.postage.length) { //ebrev web has postage, rfix does not..for now. Quick fix for now
        return mapProductsWithPostage();
      } else {
        return mapProductsWithoutPostage();
      }
    }

    function translateProduct (name) {
      return $translate.instant(name, {}, undefined, 'en');
    }

    function mapProductsWithPostage () {
      const zonesMapping = {
        '0': 'SE',
        '1': 'EU',
        '2': 'Europe',
        '3': 'outside Europe'
      };

      const addressCount = Common.get('recipients').validAddressCount || Common.get('recipients').refinedAddressCount;
      const productDelivery = Common.get('productDelivery');
      const pricing = Common.get('pricing');
      const addressType = Common.get('recipients', {}).addressType;
      const baseProductName = translateProduct(pricing.baseProduct.name);

      let priceWithoutPostage = pricing.baseProduct.priceWithVAT;

      pricing.additionalServices.forEach(function (service) { //sum everything except postages
        priceWithoutPostage += service.priceWithVAT;
      });

      return pricing.postage.map(function (postageProduct) {
        const zone = zonesMapping[postageProduct.zone] || postageProduct.zone || 'SE';
        const category = Common.getServiceCountry() + ' ' + zone;
        const skuArray = [translateProduct(productDelivery.name) + ' (' + productDelivery.productId + ')', 'Service country '
          + Common.getServiceCountry(), translateProduct(postageProduct.name), 'Postage zone ' + zone, 'Address type ' + addressType];

        pricing.additionalServices.forEach(function (service) {
          skuArray.push(translateProduct(service.name));
        });

        const price = _.round(priceWithoutPostage / addressCount, 0)
          + _.round(postageProduct.priceWithVAT / postageProduct.count, 0); //add a proportional slice of the priceWithoutPostage and the postage, divided by the count

        return {
          id: pricing.baseProduct.SAPproductId,
          name: baseProductName,
          sku: skuArray.join(','),
          price: toDecimalPrice(price),
          category: category,
          quantity: postageProduct.count,
          zone: zone,
          variant: translateProduct(postageProduct.name)
        };
      });
    }

    function mapProductsWithoutPostage () {
      const productDelivery = Common.get('productDelivery');
      const pricing = Common.get('pricing');
      const baseProductName = translateProduct(pricing.baseProduct.name);
      const recipients = Common.get('recipients', {});
      const addressType = recipients.addressType;

      const category = Common.getServiceCountry() + ' ' + 'SE'; //admail is always sent to Sweden, doubtful it will change any time soon

      const skuArray = [translateProduct(productDelivery.name) + ' (' + productDelivery.productId + ')', 'Service country ' + Common.getServiceCountry(), 'Address type ' + addressType];
      pricing.additionalServices.forEach(function (service) {
        skuArray.push(translateProduct(service.name));
      });

      let price = pricing.baseProduct.priceWithVAT;
      pricing.additionalServices.forEach(function (service) {
        price += service.priceWithVAT;
      });
      price /= recipients.refinedAddressCount; //price per unit

      return [{
        id: pricing.baseProduct.SAPproductId,
        name: baseProductName,
        sku: skuArray.join(','),
        price: toDecimalPrice(price),
        category: category,
        quantity: recipients.refinedAddressCount,
        variant: baseProductName
      }];
    }

    function toDecimalPrice (price) {
      if (!_.isNumber(price))
        return 0;

      const decimal = price / 100;
      return _.round(decimal, 2);
    }

    function mapForGTM (products) {
      if (angular.isUndefined(products) || products.length === 0) {
        return [];
      }

      const pricing = Common.get('pricing', {});

      let additionalServices = [];

      if (pricing.additionalServices) {
        additionalServices = pricing.additionalServices.map(function (item) {
          return $translate.instant(item.name, {}, undefined, pnTopbar.language);
        });

        additionalServices = additionalServices.join(',');
      }

      return products.map(function (product) {

        return {
          id: product.sku,
          name: product.name,
          price: product.price,
          variant: product.variant,
          category: 'create mail-outs',
          quantity: product.quantity,
          dimension8: product.zone || 'SE',
          dimension9: additionalServices
        };
      });
    }
  }
})();
